import styled from 'styled-components';
export const StyledBroadsiderHomeSelector = styled.div`
  border: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.frame};
  position: relative;
  padding: 1.125rem;
  width: 22rem;
  background-image: url(/assets/selector_bg.png);
  background-size: cover;
  
  .selector-contents {
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    width: 100%;
    gap: 1rem;
  }

  .selector-info {
    width: 100%;

    div {
      text-align: start !important;
    }
  }

  .selector-separator {
    height: 3px;
    background-color: rgba(253, 173, 50, 1);
    width: 100%;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }

  .selector-logo {
    width: 100%;
  }

  .selector-corner {
    width: ${({ theme }) => theme.cornerSize};
    height: ${({ theme }) => theme.cornerSize};
    border: solid ${({ theme }) => theme.frameWidth} white;
    position: absolute;
    animation: corner-scale 0.3s cubic-bezier(0.5, 0.35, 0.15, 1) 0.1s 1 normal forwards;
  }

  .selector-corner-tl {
    border-right: none;
    border-bottom: none;
    margin-top: ${({ theme }) => '-' + theme.frameWidth};
    margin-left: ${({ theme }) => '-' + theme.frameWidth};
    top: 0;
    left: 0;
  }

  .selector-corner-tr {
    border-left: none;
    border-bottom: none;
    margin-top: ${({ theme }) => '-' + theme.frameWidth};
    margin-right: ${({ theme }) => '-' + theme.frameWidth};
    top: 0;
    right: 0;
  }

  .selector-corner-br {
    border-left: none;
    border-top: none;
    margin-bottom: ${({ theme }) => '-' + theme.frameWidth};
    margin-right: ${({ theme }) => '-' + theme.frameWidth};
    bottom: 0;
    right: 0;
  }

  .selector-corner-bl {
    border-right: none;
    border-top: none;
    margin-bottom: ${({ theme }) => '-' + theme.frameWidth};
    margin-left: ${({ theme }) => '-' + theme.frameWidth};
    bottom: 0;
    left: 0;
  }

  .selector-avatars-holder {
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    justify-content: space-between;
  }

  .selector-button-content {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    div {
      padding-left: 8px;
      padding-right: 8px;
    }
  }

  @media (max-width: ${({ theme }) => theme.mobile}) {
    width: calc(100% + 2 * ${({ theme }) => theme.frameWidth});
    margin-right: -${({ theme }) => theme.frameWidth};
    margin-left: -${({ theme }) => theme.frameWidth};
    margin-bottom: -${({ theme }) => theme.frameWidth};
  }
`;

